<template>
  <div class="i-sub-menu">
    <el-submenu v-if="menu.children" :index="menu.index" :key="menu.name">
      <template slot="title">
        <i v-if="menu.meta.icon" :class="menu.meta.icon"/>
        <span>{{ menu.meta.title }}</span>
        <i class="el-icon-caret-right icon-right"/>
      </template>
      <sub-menu v-for="subItem in menu.children" :menu="subItem" :index="subItem.path" :key="subItem.name" />
    </el-submenu>
    <menu-item v-else :menu="menu" :sub-item="true" :index="menu.path" :key="menu.name"/>
  </div>
</template>

<script>
import menuItem from './menuItem'
export default {
  name: 'subMenu',
  props: {
    menu: {
      type: Object,
      default: _ => {}
    }
  },
  components: {
    menuItem
  }
}
</script>




// WEBPACK FOOTER //
// src/components/MainLayout/components/Menus/subMenu.vue